import { ToastContainer } from "react-toastify";
import { Icon } from "../icon/icon";

export const Toast = () => {
  return (
    <>
      <ToastContainer
        autoClose={3000}
        position="top-center"
        hideProgressBar
        className={"mt-[40px] gap-4 px-4 md:mt-[70px]"}
        toastClassName={(context) => {
          const defaultClass = `
            text-sm md:text-base font-bold
            flex items-center
            rounded-full p-[18px] 
            min-w-fit max-w-[90%] mx-auto
            `;

          switch (context?.type) {
            case "info":
              return `bg-primary text-white` + defaultClass;
            case "error":
              return `bg-danger text-white` + defaultClass;
            case "success":
              return `bg-primary text-white` + defaultClass;
            case "warning":
              return `bg-primary text-white` + defaultClass;
            default:
              return `bg-primary text-white` + defaultClass;
          }
        }}
        icon={({ type }) => {
          switch (type) {
            case "info":
              return <Icon svg="circle-check" width={20} height={20} />;
            case "error":
              return <Icon svg="circle-close" width={20} height={20} />;
            case "success":
              return <Icon svg="circle-check" width={20} height={20} />;
            case "warning":
              return <Icon svg="circle-check" width={20} height={20} />;
            default:
              return null;
          }
        }}
        closeButton={false}
      />
    </>
  );
};
